import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "@apollo/client";

import {
  CampaignMinimalFragment,
  CAMPAIGN_MINIMAL_FRAGMENT,
} from "../../fragments";
import { CampaignsQueryVariables, Collection } from "../../types";

export const GET_CAMPAIGNS = gql`
  query getCampaigns(
    $page: Int
    $per: Int
    $q: String
    $sortBy: String
    $direction: String
  ) {
    campaigns(
      page: $page
      per: $per
      q: $q
      sortBy: $sortBy
      direction: $direction
    ) {
      collection {
        ...CampaignMinimalFragment
      }
      metadata {
        totalCount
      }
    }
  }
  ${CAMPAIGN_MINIMAL_FRAGMENT}
`;

export type CampaignsData = {
  campaigns: Collection<CampaignMinimalFragment>;
};

export default (
  options?: QueryHookOptions<CampaignsData, CampaignsQueryVariables>
) => {
  return useQuery<CampaignsData, CampaignsQueryVariables>(
    GET_CAMPAIGNS,
    options
  );
};
